import React from 'react';
import { Box } from '@mui/material';
import { HotelSidebar } from './HotelSidebar';
import { Outlet } from 'react-router-dom';

const HotelDashboard = () => {
  return (
    <Box sx={{ display: 'flex' }}>
      <HotelSidebar />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          minHeight: '100vh',
          width: { xs: '100%', sm: `calc(100% - 240px)` },
          ml: { xs: 0, sm: `240px` },
          transition: 'margin 0.2s ease-in-out',
          overflow: 'hidden',
          backgroundColor: '#f5f5f5',
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
};

export default HotelDashboard;
